import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'start-button',
    templateUrl: 'start-button.component.html',
    styleUrls: ['start-button.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StartButtonComponent implements OnInit {

    @Input() buttonTitle: String;
    @Output() notify: EventEmitter<string> = new EventEmitter<string>();

    start() {
        this.notify.emit('start');
    }

    ngOnInit() {
        // this.buttonTitle = 'Start Test';
    }
}
